import { ApolloClient, HttpLink, InMemoryCache, from } from '@apollo/client';
import { setContext } from '@apollo/client/link/context';
import { onError } from '@apollo/client/link/error';
import { API_AUTH_URL, API_COURSE_URL, AUTH_TOKEN_KEY } from '../utils/constants';

const authLink = setContext((_, { headers }) => {
  const token = localStorage.getItem(AUTH_TOKEN_KEY);
  return {
    headers: {
      ...headers,
      authorization: token ? `Bearer ${token}` : "",
    }
  };
});

const errorLink = onError(({ graphQLErrors, networkError }) => {
  if (graphQLErrors) {
    graphQLErrors.forEach(({ message, locations, path }) => {
      console.error(
        `[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`
      );
    });
  }

  if (networkError) {
    console.error(`[Network error]: ${networkError}`);
    if (networkError.message.includes('401') || networkError.message.includes('403')) {
      localStorage.removeItem(AUTH_TOKEN_KEY);
      window.location.href = '/login';
    }
  }
});

const createHttpLink = (uri: string) => {
  return new HttpLink({
    uri,
    credentials: 'omit', 
    fetch: (input: RequestInfo | URL, init?: RequestInit) => {  
     
      const controller = new AbortController();
      const timeoutId = setTimeout(() => controller.abort(), 10000); 
      
      return fetch(input, {
        ...init,
        signal: controller.signal,
        mode: 'cors', 
      }).finally(() => clearTimeout(timeoutId));
    }
  });
};


export const authClient = new ApolloClient({
  link: from([authLink, errorLink, createHttpLink(`${API_AUTH_URL}/graphql`)]),
  cache: new InMemoryCache(),
  defaultOptions: {
    watchQuery: {
      errorPolicy: 'all',
    },
    query: {
      errorPolicy: 'all',
    },
  }
});


export const courseClient = new ApolloClient({
  link: from([authLink, errorLink, createHttpLink(`${API_COURSE_URL}/graphql`)]),
  cache: new InMemoryCache(),
  defaultOptions: {
    watchQuery: {
      errorPolicy: 'all',
    },
    query: {
      errorPolicy: 'all',
    },
  }
});